













































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
// import { TransferTransaction, Message, PublicAccount } from 'nem2-sdk';
import DynamicDivider from '@/components/DynamicDivider.vue';
import MobileDetectionMixin from '@/assets/ts/mixins/MobileDetectionMixin';
// import { IAssetInfo } from '@/store/modules/asset/interface';

import {VerifyInfo } from '@luxtag/papybase';
import {clone, isEmpty} from 'lodash';
import moment from 'moment';

@Component({
    components: {
        DynamicDivider,
    },
    filters: {
        eachContent(item: any) {
            if (moment(item).isValid()) {
                if (isNaN(item)) { return moment(item).format('MMMM Do YYYY'); }
            }
            return item;
        }
    }
})
export default class CertificateInformation extends Mixins(MobileDetectionMixin) {
    @Prop({ default: false }) public carouselTopRadius!: boolean;
    // @Prop() public assetAccount!: any | null;
    @Prop() public verifyInfo!: any | null;
    @Prop({ default: '' }) public merchant!: string;

    public certContent: any = null;

    // get assetInfo(): IAssetInfo | undefined {
    //     if (this.assetAccount) {
    //         return this.$store.getters.getAssetCreationInfoByPublicKey(this.assetAccount.publicKey);
    //     } else {
    //         return;
    //     }
    // }

    get certIssuer(): string {
        return this.merchant;
    }

    get certImgs(): string[] {
        if (!isEmpty(this.verifyInfo)) {
            if (!isEmpty(this.verifyInfo.payload)) {
                if (this.verifyInfo.payload.data.img) {
                    return [this.verifyInfo.payload.data.img];
                }
                if (this.verifyInfo.payload.data.photo) {
                    return [this.verifyInfo.payload.data.photo];
                }
            }
        }

        return [];
    }

    // get certTag() {
    //      if (this.assetInfo) {
    //         return this.assetInfo.message.id;
    //     } else {
    //         return '';
    //     }
    // }

    @Watch('verifyInfo', {immediate: true})
    public onChildChanged(val: any, oldVal: any) {
        if (val) {
            if (!val.personnel) {
                const clonedData = clone(val.payload.data);
                this.$set(this, 'certContent', this.cleanContent(clonedData));
            } else {
                const clonedData = clone(val.personnel);
                this.$set(this, 'certContent', this.cleanPersonnelContent(clonedData));
            }
        }
    }

    private cleanContent(data: any) {
        delete data.img;
        delete data.photo;
        const keys = Object.keys(data);
        if (keys.indexOf('Serial Numer') >= 0) {
            data['Serial Number'] = data['Serial Numer'];
            delete data['Serial Numer'];
        }
        return data;
    }

    private cleanPersonnelContent(data: any) {
        delete data.certificates;
        delete data.public_key;
        delete data.address;
        delete data.createdAt;
        delete data.updatedAt;
        return data;
    }
}
